import 'swiper-9/css';
import ProjectDetailsCard from '~/javascripts/components/User/ProfileMap/ProjectDetailsCard';
import Swiper, { Navigation, Pagination, Virtual } from 'swiper-9';
import externalAjaxRequest from '~/javascripts/utils/externalAjaxRequest';
import store from '~/javascripts/store.js';
import { observer, useLocalObservable } from 'mobx-react';
import { reaction, set } from 'mobx';
import { useEffect, useLayoutEffect } from 'react';

const InnerSwiper = observer(({ parentSlideCountry, projects }) => {
  const localStore = useLocalObservable(() => ({
    innerSwiper: null,
    isInitialized: false,
    photosList: {},
  }));

  useLayoutEffect(() => {
    if (!localStore.photoUrlsLoaded) {
      fetchProjectPhotos();
    }
  }, [store.projectDetailsMap.outerSwiperInitialized]);

  useEffect(() => {
    reaction(
      () => [
        store.projectDetailsMap.outerSwiperSlideIndex,
        store.projectDetailsMap.outerSwiperInitialized,
        store.projectDetailsMap.focusedProjectId,
      ],
      () => {
        if (
          store.projectDetailsMap.selectedCountryCode == parentSlideCountry &&
          store.projectDetailsMap.outerSwiperInitialized
        ) {
          initializeViewableInnerSwiper();
        }
      }
    );
  }, []);

  const fetchProjectPhotos = () => {
    projects.map((project) => {
      externalAjaxRequest({
        dataType: 'json',
        url: `${store.projectDetailsMap.pichaPhotosUrl}/${project.short_code}`,
        type: 'GET',
        success: (data) => {
          set(localStore.photosList, project.short_code, data);
        },
      });
    });
  };

  const initializeViewableInnerSwiper = () => {
    if (!localStore.isInitialized) {
      localStore.innerSwiper = new Swiper(
        `.swiper-slide[data-country='${store.projectDetailsMap.selectedCountryCode}'] .inner-slider`,
        {
          modules: [Navigation, Pagination, Virtual],
          initialSlide: store.projectDetailsMap.innerSwiperSlideIndex,
          slidesPerView: 'auto',
          grabCursor: true,
          speed: 300,
          autoplay: false,
          effect: 'slide',
          mousewheelControl: 1,
          slidesOffsetBefore: 0,
          centeredSlides: true,
          allowTouchMove: true,
          watchSlidesProgress: true,
          breakpoints: {
            600: {
              virtual: true,
            },
            750: {
              direction: 'vertical',
            },
          },
          pagination: {
            el: '.inner-pagination',
            type: 'fraction',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-down',
            prevEl: '.swiper-button-up',
          },
          on: {
            afterInit: (swiper) => {
              slideToInnerIndex(swiper);
              localStore.isInitialized = true;
            },
          },
        }
      );
    } else {
      slideToInnerIndex(localStore.innerSwiper);
    }
  };

  const setInnerSlideIndex = () => {
    store.projectDetailsMap.innerSwiperSlideIndex =
      localStore.innerSwiper.realIndex;
  };

  const slideToInnerIndex = (swiper) => {
    swiper.slideTo(store.projectDetailsMap.innerSwiperSlideIndex, 100, false);
  };

  return (
    <>
      <div
        className='swiper inner-slider'
        id={`inner-swiper-${parentSlideCountry}`}
        style={{ width: '100%', height: '100%' }}
      >
        <div className='swiper-wrapper'>
          {projects.map((project, index) => (
            <ProjectDetailsCard
              isFirstProject={index == 0}
              key={project.id}
              project={project}
              projectPhotoUrls={localStore.photosList[project.short_code]}
            />
          ))}
        </div>
        <div className='inner-pagination' />
        {projects.length > 1 && (
          <>
            <div className='swiper-button-up' onClick={setInnerSlideIndex} />
            <div className='swiper-button-down' onClick={setInnerSlideIndex} />
          </>
        )}
      </div>
    </>
  );
});

export default InnerSwiper;
